import React, { useContext, useEffect, useState } from "react";
import { Fragment } from "react";
import { HeaderTitle } from "../Header/HeaderStyle";
import styled from "styled-components";
import { BlackXSrc, IC } from "../../../resources/Assets";
import FloatButton from "../../../components/UI/Button/FloatButton";
import Contents from "./Contents";
import { PostApi1975 } from "../../../modules/network/padoPost";
import { AppContext } from "../../../components/AppProvider";
import { Layer } from "../../../components";
import { _O } from "../../../modules/utils";
import { NativeAction } from "../../../modules/utils/HandleWs";
import useTitle from "../../../modules/hooks/useTitle";

const CouponList = props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const { setCouponListView, setUseCoupon } = props;
  const [couponList, setCouponList] = useState([]);

  const [viewMsgLayer, setViewMsgLayer] = useState(false);
  const [activeCoupon, setActiveCoupon] = useState(props.useCoupon);

  const getMyCoupon = () => {
    PostApi1975(userinfo, cfg, "TM", "ALL")
      .then(result => {
        if (result.rsltCd === "E000") {
          setCouponList(result.rslt);
        }
      })
      .catch(err => {
        console.log("err:: ", err);
      });
  };

  useTitle("마이페이지_내쿠폰함");

  useEffect(() => {
    getMyCoupon();
    NativeAction(phonecfg, "statusColor", "#FFFFFF");
  }, []);

  const bottomBtnEvent = () => {
    setUseCoupon(activeCoupon);
    setCouponListView(false);
  };

  return (
    <Fragment>
      <BackgroundDiv>
        <HeaderTitle>
          <div style={{ width: "40px", height: "40px" }}>
            {/* <img src={IC.etc.ICON_CHEVRON_LEFT} /> */}
          </div>
          {/* <div>약국정보</div> */}
          <div>내 쿠폰함</div>
          <div
            style={{ width: "40px", height: "40px" }}
            onClick={() =>
              // setUseCoupon ? setCouponListView(false) : _O.OpenMenu("/mp")
              setUseCoupon ? setCouponListView(false) : window.history.back()
            }>
            <img src={BlackXSrc} />
          </div>
        </HeaderTitle>

        <Body>
          <BodyTop>
            <TopText
              color="#333"
              onClick={() => setViewMsgLayer(!viewMsgLayer)}>
              사용 가능한 쿠폰
            </TopText>
            <TopText color="#888">{couponList.length} 개</TopText>
          </BodyTop>

          {couponList.length > 0 && (
            <Contents
              contentList={couponList}
              activeCoupon={activeCoupon}
              setActiveCoupon={setActiveCoupon}
            />
          )}
        </Body>

        <FloatButton
          severity="primary"
          disable="off"
          padding={true}
          bottomMenu={false}
          event={() => {
            setUseCoupon ? bottomBtnEvent() : _O.OpenMenu("/mp");
          }}
          text="확인"
        />
      </BackgroundDiv>

      {viewMsgLayer && (
        <Layer
          // headerIcon={IC.check.ICON_PURPLE_CHECK}
          title="사용 가능한 쿠폰이 없습니다"
          desc={["이전 페이지로 이동합니다"]}
          ps=""
          button={[
            {
              severity: "primary",
              disable: "off",
              small: false,
              // clickEvent: () => _O.Open("/mp"),
              clickEvent: () => setCouponListView(false),
              text: "확인",
            },
          ]}
        />
      )}
    </Fragment>
  );
};

const BackgroundDiv = styled.div`
  /* background: #fff; */
  background-color: #f5f5f5;
  display: flex;
  flex-flow: column;
  /* flex-wrap: wrap; */
  height: 100vh;
`;

const Body = styled.div`
  height: 100%;
  align-self: stretch;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 8px;
  padding: 24px 20px;
  overflow-y: auto;
  padding-bottom: 122px;
`;

const BodyTop = styled.div`
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0;
`;

const TopText = styled.div`
  height: 22px;
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: ${props => props.color};
`;

export default CouponList;
